<div class="row mt-4">
    <div class="col-md-12">
        <h5 class="font26 font500">All Others</h5>
        <div class="row">
            <div *ngFor="let cat of otherCategories" class="col-lg-2 col-4 col-md-3 d-flex align-items-stretch mt-4">
                <div class="card border-0 borderRadius10 cardShadow w-100">
                    <div class="card-body text-center pb-0">
                        <img [src]="cat.ImageURL" class="img-fluid"
                            alt="hamburger 2" />
                    </div>
                    <div class="card-footer bg-white border-0 text-center">
                        <p class="mb-0 font16 font500">{{cat.Header}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>